<template>
    <div class="graphic__container">
        <div class="graphic-title">{{title}}</div>
        <div class="graphic">
            <PieChart v-if="graph.datasets[0].data.length > 0" :chartData="graph" :options="graphicOptions"/>
        </div>
        <div class="graphic-labels">
            
            <div @click="openDashboardDetail(property)" v-for="(value,property) in graphicColors" :key="property" class="graphic-label">
                <i class="material-icons" :style="{color: commonColors[value]}">circle</i>
                <span>{{$t(`forge_dashboard.${property}`)}}: <strong>{{getValue(property)}}</strong></span>
            </div>
            
        </div>
    </div>
</template>

<script>
import { PieChart } from 'vue-chart-3';
import { Chart, registerables } from "chart.js";
import { onMounted, ref } from 'vue';
Chart.register(...registerables);
import { useI18n } from 'vue-i18n';

export default {
    components:{
        PieChart,
    },
    props: {
        
        title: String,
        graphicColors: Object,
        graphicData: Array,
        graphicDataKey: String,
        idData: Object,
        spName: String
    },
    setup(props){
        const { t } = useI18n();
        const graph = ref({ labels: [],datasets: [ { data: [], backgroundColor: [] } ] });
        const itemLabels = ref([]);
        const itemValues = ref([]);
        const commonColors = {
            red: '#B81D02',
            lightred: '#DE5D00',
            yellow: '#E7B400',
            lightgreen: '#00A94E',
            green: '#007A38'
        }
        const graphicOptions = {
            plugins: {
                tooltip: {
                    enabled: true,
                    //mode: 'single',
                    callbacks: {
                        label: function (tooltipItems) {
                            return  ` ${tooltipItems.formattedValue}%`;
                        }
                    },     
                    legend: {
                        display:true,
                        onHover: (event) => {
                            event.native.target.style.cursor = 'pointer'
                        }
                    }
                }
            },
            onHover: (event, chartElement) => {
                const target = event.native ? event.native.target : event.target;
                target.style.cursor = chartElement[0] ? 'pointer' : 'default';
            },
            onClick: (e,dataIndex)=>{
                openDashboardDetail(itemLabels.value[dataIndex[0].index] )
                /*
                let sp = {
                    spName : props.spName,
                    spData : { 
                        detailKey: props.graphicDataKey,
                        detailValue: itemLabels.value[dataIndex[0].index] 
                    }
                }
                sp.spData[props.idData.name] = props.idData.id;
                parent.postMessage(JSON.stringify({
                    type:"FullNavigate",
                    data: {
                        module:"Referenciales",
                        view:"ShowDataView",
                        params: {
                            params : [
                                {
                                    dataType:"ExternalDashboardData",
                                    originalData: JSON.stringify(sp)
                                }
                            ]
                        },
                        tabName: `Reporte ${props.title} -  ${t(`forge_dashboard.${itemLabels.value[dataIndex[0].index]}`)}`
                    }
                }),"*");
                */
            },
        }

        function openDashboardDetail(itemLabel){
            let sp = {
                    spName : props.spName,
                    spData : { 
                        detailKey: props.graphicDataKey,
                        detailValue: itemLabel
                    }
                }
                sp.spData[props.idData.name] = props.idData.id;
                parent.postMessage(JSON.stringify({
                    type:"FullNavigate",
                    data: {
                        module:"Referenciales",
                        view:"ShowDataView",
                        params: {
                            params : [
                                {
                                    dataType:"ExternalDashboardData",
                                    originalData: JSON.stringify(sp)
                                }
                            ]
                        },
                        tabName: `Reporte ${props.title} -  ${t(`forge_dashboard.${itemLabel}`)}`
                    }
                }),"*");
        }

        const loadGraphicData = (items) => {
            items.forEach(item => {    
                graph.value.datasets[0].data.push(item.percentage);
                graph.value.datasets[0].backgroundColor.push(commonColors[props.graphicColors[item.name]]);
                itemLabels.value.push(item.name);
                itemValues.value.push({name:item.name,valor:item.value});
                //graph.value.labels.push(item.name);
            });
        }
       onMounted(()=>{
            loadGraphicData(props.graphicData);
        })

        function getValue(property){
            //let obj = itemValues.value.find(item => item.name == property);
            let index = itemValues.value.findIndex(item => item.name == property);
            if(index >=0) return itemValues.value[index].valor;
            else return 0;
        }
        
        return{
            openDashboardDetail,
            graph,
            commonColors,
            graphicOptions,
            itemValues,
            getValue
        }
    },
}
</script>

<style lang="scss" scoped>

.graphic__container{
    display: flex;
    flex-flow: column nowrap;
    width: 33.3%;
    padding: 16px;
    border: 1px solid #C4C4C4;
    border-radius: 4px;
    .graphic-title{
        padding-bottom: 8px;
        width: 100%;
        text-align: center;
        font-weight: bold;
    }
    .graphic{
        >div{
            height: 250px;
        }
    }
    .graphic-labels{
        flex-grow: 1;
        margin-top: 36px;
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 8px;
        .graphic-label{
            width: 100%;
            padding-left: 4px;
            display: flex;
            align-items: center;
            gap: 4px;
            cursor: default;
            :hover {
                cursor: pointer;
            }
            i{
                font-size: 22px;
            }
            span{
                font-size: 14px;
            }         
        }
    }
}
</style>
